export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-porcelain border-t border-bone pt-24 pb-12"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-10 lg:px-16">
        {/* Massive wordmark */}
        <div className="border-b border-bone pb-16 mb-16">
          <div
            className="text-ink text-[12vw] md:text-[9vw] lg:text-[7.5vw] leading-[0.9] tracking-tighter select-none"
            style={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 400 }}
          >
            Apex Dental Care<span className="text-taupe">.</span>
          </div>
          <div className="mt-6 font-malayalam text-3xl md:text-4xl text-ink/70 leading-none">
            ദന്താശുപത്രി
          </div>
          <div className="mt-6 eyebrow">Dental Care · Root Canal & Aesthetic Dentistry</div>
        </div>

        <div className="grid grid-cols-12 gap-6 md:gap-10 mb-20">
          <div className="col-span-12 md:col-span-4">
            <div className="eyebrow mb-4">Address</div>
            <a
              href="https://maps.app.goo.gl/abxZS66jBguHm6Ru6"
              target="_blank"
              rel="noopener noreferrer"
              className="font-serif text-lg md:text-xl leading-snug text-ink hover:text-taupe transition-colors duration-500 block"
              data-testid="footer-maps-link"
            >
              Ground Floor, Kodanchery Arcade,<br />
              Edamuttam Kattoor Road,<br />
              Edamuttam · Kerala
            </a>
            <a
              href="https://maps.app.goo.gl/abxZS66jBguHm6Ru6"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center gap-2 eyebrow link-underline"
              data-testid="footer-directions-cta"
            >
              <span>View on Google Maps</span>
              <span aria-hidden>→</span>
            </a>
          </div>
          <div className="col-span-6 md:col-span-3">
            <div className="eyebrow mb-4">Reach</div>
            <a
              href="tel:+919961717181"
              className="text-lg md:text-xl block link-underline w-fit"
              style={{ fontFamily: '"Outfit", sans-serif', fontWeight: 400, fontVariantNumeric: 'tabular-nums', letterSpacing: '0.02em' }}
            >
              +91 99617 17181
            </a>
          </div>
          <div className="col-span-6 md:col-span-3">
            <div className="eyebrow mb-4">Hours</div>
            <p className="font-serif text-lg md:text-xl leading-snug">
              Mon – Sat<br />9:30 AM – 6:00 PM<br /><span className="text-ink/60">Sunday · Closed</span>
            </p>
          </div>
          <div className="col-span-12 md:col-span-2 flex md:justify-end">
            <a
              href="#booking"
              className="eyebrow link-underline"
              data-testid="footer-book-cta"
            >
              Reserve →
            </a>
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-ink/60 text-xs tracking-[0.18em] uppercase">
          <div>© {new Date().getFullYear()} · APEX Dental Care</div>
          <div>Designed with therapy · Edamuttam, Kerala</div>
        </div>
      </div>
    </footer>
  );
}
